import React from "react";

function SubjectCountBoxList({ subname, sublogo, draft, completed }) {
  const isMore = subname.length > 8;
  return (
    // <div className="summery_card p-2" style={{ height: "132px" }}>
    //     <div className={isMore ? "summery_card_subject d-flex align-items-center justify-content-between subHover" : "summery_card_subject d-flex align-items-center justify-content-between "}>
    //         <span>{subname}</span>
    //         <img
    //             className="summery_card_subjext_icon"
    //             src={sublogo}
    //             alt=""
    //             onError={(e) => {
    //                 e.target.src = '/subIcon/ic_png_science.png'
    //             }} />
    //     </div>
    //     <div className="summery_box_items ">
    //         <span>Draft .&nbsp; </span>
    //         <span>{draft}</span>
    //     </div>
    //     <div className="summery_box_items ">
    //         <span>Completed .&nbsp; </span>
    //         <span>{completed}</span>
    //     </div>
    // </div>

    <div
      className="py-1 px-3 text-center shadow-sm rounded-4 mb-1 "
      style={{
        minWidth: "250px",
        maxWidth: "350px",
        backgroundColor: "#FDEFE3",
        borderTop: "2px solid #8D4B28", // top border
        borderRight: "4px solid #8D4B28", // right border (thicker)
        borderBottom: "1px solid #8D4B28",
        borderLeft: "1px solid #8D4B28",
        borderRadius: "0.75rem",
      }}
    >
      <div className="d-flex flex-column align-items-center mb-1">
        <img
          src={sublogo}
          alt={""}
          style={{ height: "32px" }}
          onError={(e) => {
            e.target.src = "/subIcon/ic_png_science.png";
          }}
        />
        <h6
          className="mt-1 fw-bold text-brown mx-auto text-truncate poppins-semibold"
          title={subname}
          style={{
            maxWidth: "100%", // allows truncation to work
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            hover: "pointer",
            color: "#8D4B28",
          }}
        >
          {subname}
        </h6>
      </div>

      <div className="d-flex justify-content-around gap-2 border-top pt-2 text-muted small fw-semibold">
        <div className="d-flex flex-column">
          <small className="text-sm poppins-semibold">Draft</small>
          <small className="text-dark poppins-semibold">
            {draft > 0 ? String(draft).padStart(2, "0") : "0"}
          </small>
        </div>

        <div
          className="mx-2"
          style={{
            width: "2px",
            backgroundColor: "#333",
            opacity: 0.5,
          }}
        ></div>

        <div className="d-flex flex-column px-3">
          <small className="text-nowrap poppins-semibold">Completed</small>
          <small className="text-dark poppins-semibold">
            {completed > 0 ? String(completed).padStart(2, "0") : "0"}
          </small>
        </div>
      </div>
    </div>
  );
}

export default SubjectCountBoxList;
